var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c(
      "div",
      {
        staticClass: "dm-platform-rating dm-new-rating",
        on: {
          mouseleave: function($event) {
            _vm.hoveredStar = 0
          }
        }
      },
      _vm._l(5, function(score) {
        return _c(
          "span",
          {
            key: "score-" + score,
            staticClass: "dm-star",
            class: {
              "dm-gold-star":
                score <= _vm.hoveredStar ||
                (_vm.hoveredStar == 0 && score <= _vm.ratingData.score)
            },
            on: {
              mouseover: function($event) {
                return _vm.setHoveredStars(score)
              },
              click: function($event) {
                return _vm.setScore(score)
              }
            }
          },
          [_c("svg-icon", { attrs: { icon: "star" } })],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "dm-platform-rating-feedback" }, [
      _c("span", [
        _vm._v(
          "We'd like to hear your feedback, it will help us improve in the future."
        )
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.ratingData.message,
            expression: "ratingData.message"
          }
        ],
        staticClass: "form-control",
        attrs: {
          name: "",
          id: "",
          cols: "30",
          rows: "5",
          placeholder: "Message..."
        },
        domProps: { value: _vm.ratingData.message },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.ratingData, "message", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "button",
          {
            staticClass: "btn dm-submit",
            class: { disabled: !_vm.buttonActive },
            attrs: { disabled: !_vm.buttonActive },
            on: {
              click: function($event) {
                return _vm.submitRating()
              }
            }
          },
          [_vm._v("Submit")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }